
import { copyToClip } from '~/utils/index'
import Copy from '@/components/PZIcons/Copy'
import GoodsSimpleMessage from '../CSS/GoodsSimpleMessage.vue'
import GoodsCombo from '../CSS/GoodsCombo.vue'
import OrderBoxStatus from './OrderBoxStatus.vue'
import { orderStatusBySeller } from '@/enum/localEnum'
import FlashSale from '../CSS/FlashSale.vue'
import OrderBoxKan from './OrderBoxKan.vue'
import GoodsTags from '../CSS/GoodsTags.vue'
import { formatCount } from '@/utils'
export default {
	name: 'OrderBoxBuyerGoods',
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	components: {
		Copy,
		GoodsSimpleMessage,
		OrderBoxStatus,
		GoodsCombo,
		FlashSale,
		OrderBoxKan,
		GoodsTags
	},
	data() {
		return {
			sellerInfo: {}
		}
	},
	computed: {
		getTime() {
			const { status, oneselfDownStandTime, forceDownStandTime, verifyTime, transactionTime, onStandTime, createTime } = this.item
			let label = null
			let value = ''
			switch (status) {
				case orderStatusBySeller.ONESELF_DOWN_STAND:
					label = '下架时间'
					value = oneselfDownStandTime
					break
				case orderStatusBySeller.FORCE_DOWN_STAND:
					label = '下架时间'
					value = forceDownStandTime
					break
				case orderStatusBySeller.VERIFY_FAIL:
					label = '审核时间'
					value = verifyTime
					break
				case orderStatusBySeller.BEAN_SOLD:
					label = '成交时间'
					value = transactionTime
					break
				case orderStatusBySeller.ON_STAND:
					label = '上架时间'
					value = onStandTime
					break
				// 待审核和交易中
				default:
					label = '创建时间'
					value = createTime
					break
			}
			if (!value) return ''
			return `${label} ${value}`
		},
		goodsNumInfo() {
			// TODO： 这里的字段都不确定
			const { viewsNum, sellNum, hots, collectionNum, allStock, monthlySales, goodsCatalogueId, status } = this.item || {}
			const arr = []
			const view = {
				label: '曝光',
				value: formatCount(viewsNum || 0) // 总浏览量
			}
			arr.push(view)
			if (goodsCatalogueId === 6) {
				// 成品号就是曝光+想要
				const hot = {
					label: '想要',
					value: formatCount(hots || 0)
				}

				arr.push(hot)
			} else {
				// 通用商品的字段为：【曝光】【收藏】【销量】【库存】
				const collect = {
					label: '收藏',
					value: formatCount(collectionNum || 0)
				}
				const stock = {
					label: '库存',
					value: formatCount(allStock || 0)
				}
				const sale = {
					label: '销量',
					value: formatCount(monthlySales || 0)
				}
				arr.push(collect)
				arr.push(sale)
				arr.push(stock)
			}
			return arr.map(item => `${item.label} ${item.value}`).join('-')
		}
	},
	created() {
		this.getGeneralGoodsSellerInfo()
	},
	methods: {
		// 获取卖家信息
		async getGeneralGoodsSellerInfo() {
			if (this.item.goodsCatalogueId === 6) {
				return
			}
			const p = {
				goodsNo: this.item.goodsNo
			}
			const res = await this.$api.getGeneralGoodsSellerInfo(p)
			this.sellerInfo = res.data || {}
		},
		handleCopyId(id) {
			copyToClip(id, '已复制')
		},
		getTypeName(item) {
			if (item.orderType === 'GENERAL') {
				if (item.orderStatus === 'COMPLETE' || item.orderStatus === 'PAY_SUCCESS') {
					return '已付款'
				} else {
					return '需支付'
				}
			} else {
				return '需支付'
			}
		},
		gotoDetails(item) {
			if (item.goodsCatalogueId === 6) {
				this.$router.push({
					path: '/account/sellerDetails',
					query: {
						orderStatus: item.statusName,
						status: item.status,
						goodsNo: item.goodsNo,
						gameId: item.gameId,
						goodsCatalogueId: item.goodsCatalogueId
					}
				})
			} else {
				this.$router.push({
					path: '/account/sellerOtherDetails',
					query: {
						goodsNo: item.goodsNo,
						gameId: item.gameId,
						goodsCatalogueId: item.goodsCatalogueId,
						goodsSubCatalogueId: item.goodsSubCatalogueId
					}
				})
			}
		}
	}
}
